import { useTranslation } from 'react-i18next'

import { RequestNonpfrofitModalProps } from './RequestNonprofitModal.types'
import { AcknowledgeModal, ConfirmationModal, Modal, Text } from '@percent/lemonade'

export function RequestNonprofitModal({ type, handleClose, handleSubmit, openModal }: RequestNonpfrofitModalProps) {
  const { t } = useTranslation()

  const aknowledgeModalProps = {
    success: {
      result: 'positive' as 'positive' | 'negative',
      title: t('workplace_giving.nonprofit.request.modal.success.title'),
      description: t('workplace_giving.nonprofit.request.modal.success.description'),
      buttonText: t('workplace_giving.common.done'),
      handleClose
    },
    error: {
      result: 'negative' as 'positive' | 'negative',
      title: t('workplace_giving.nonprofit.request.modal.error.title'),
      description: t('workplace_giving.nonprofit.request.modal.error.description'),
      buttonText: t('workplace_giving.common.done'),
      handleClose
    },
    cancel: {
      title: t('workplace_giving.fundraiser.modal.cancel.title'),
      primaryButtonText: t('workplace_giving.common.confirm'),
      secondaryButtonText: t('workplace_giving.fundraiser.modal.cancel.secondaryButtonText'),
      handleClose,
      handleSubmit: handleSubmit || (() => {})
    }
  }

  return (
    <Modal borderRadiiSize="xlarge" open={openModal}>
      {type === 'cancel' ? (
        <ConfirmationModal
          {...aknowledgeModalProps.cancel}
          primaryBtnTestId="confirm-cancel-btn"
          secondaryBtnTestId="cancel"
          buttonShape="oval"
        >
          <Text size="small">{t('workplace_giving.nonprofit.request.modal.cancel.description')}</Text>
        </ConfirmationModal>
      ) : (
        <AcknowledgeModal {...aknowledgeModalProps[type]} buttonShape="oval" />
      )}
    </Modal>
  )
}
